import React, { ReactElement, ChangeEvent, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { DashlineSeparator, HCaptchaContainer, buttonStyle } from '../../../components/common/CommonStyle';
import HCaptcha from '../../../components/auth/Hcaptcha';
import EmailInputV2 from '../../../atoms/EmailInputV2';
import Button from '../../../atoms/buttons/Button';
import EmailCaption from './EmailCaption';
import { OtpNextButtonWrapper, customLabelStyle, emailInputStyle } from './ChangeEmailStyle';
import { RootState } from '../../../store';
import { changeEmailValidateNewEmailAction } from '../../../actions/authActions';
import { isQAautomation, isQAautomationEmail } from '../../../utils/helpers';

const ChangeNewEmail = (props): ReactElement => {
  const { email, newEmail, setNewEmail, newEmailCaptcha, setNewEmailCaptcha, emailVerifyData } = props;
  const [, setHasValidEmail] = React.useState<boolean>(false);
  const [hasError, setHasError] = React.useState<boolean>(false);

  const dispatch = useDispatch();
  const { isMemberCaptchaEnabled, cf_country } = useSelector((state: RootState) => state.attributes);

  useEffect(() => {
    if (emailVerifyData?.hasError) {
      setHasError(true);
      setNewEmailCaptcha('');
    }
  }, [emailVerifyData]);

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;

    setNewEmail(value);
  };

  const handleNewEmailSubmit = (): void => {
    const token = emailVerifyData?.via === 'password' ? emailVerifyData?.pass_token : emailVerifyData?.email_token;

    dispatch(changeEmailValidateNewEmailAction(newEmail, 'change_email', token, emailVerifyData?.via, newEmailCaptcha));
  };

  const disableButton: boolean =
    isEmpty(newEmail) ||
    hasError ||
    (isMemberCaptchaEnabled && isEmpty(newEmailCaptcha) && !(isQAautomation() || isQAautomationEmail(newEmail)));

  return (
    <>
      <EmailCaption label={'Current email:'} email={email} />
      <DashlineSeparator />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <EmailInputV2
          id={'change_new_email'}
          inputLabel="Please provide your new email"
          placeHolder="Enter your email here"
          value={newEmail}
          onChange={onChangeEmail}
          autoFocus
          autoSuggestStyle={{ maxWidth: '100%' }}
          customStyle={{ marginRight: 0, width: '100%', maxWidth: '100%' }}
          customContainerStyle={{ marginBottom: 8 }}
          customStyleLabel={customLabelStyle}
          status={hasError ? 'error' : 'default'}
          statusMessage={hasError && emailVerifyData?.error?.message ? emailVerifyData?.error?.message : null}
          setHasValidEmail={setHasValidEmail}
          onError={setHasError}
          customInputStyle={emailInputStyle}
          isLogin={false}
        />

        {isMemberCaptchaEnabled && (
          <HCaptchaContainer>
            <HCaptcha storeCaptchaResponse={setNewEmailCaptcha} cfCountry={cf_country} resetCaptcha={hasError} />
          </HCaptchaContainer>
        )}
      </div>

      <OtpNextButtonWrapper style={{ marginBottom: 0 }}>
        <Button
          disabled={disableButton}
          customStyle={{ ...buttonStyle, marginBottom: 0 }}
          buttonType="primaryRed"
          type="button"
          name="commit"
          onClick={handleNewEmailSubmit}
        >
          Send Verification
        </Button>
      </OtpNextButtonWrapper>
    </>
  );
};

export default ChangeNewEmail;
